import axios from 'axios'

const default_error_message = 'Error accesing the requested resource.'
const default_status_code = 400
const success_alert = {message: 'Success!', variant:'success', timer: 1000}
const error_alert = {message: default_error_message, variant:'danger'}

export const client = axios.create({
    json: true
})

const execute = async(method, {service, resource}, data, config) => { 
    const accessToken = localStorage.getItem('jwt')
    const request = {
        method,
        baseURL: service,
        url: resource,
        data,
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        ...(config || {})
    }
    try{
        const { data } = await client(request)
        return data
    } catch(e){
        const data = e.response && e.response.data
        error_alert.message = (data && data.message) ||
            (data && data.data && data.data.error) ||
            default_error_message

        let status_code = data && data.status_code != null ? data.status_code : default_status_code

        console.log("ex:" + status_code + ":" + error_alert.message)

        if (status_code == 403) {
            localStorage.clear()
            window.location.href = "./#/login";
        }
        
        throw e
    }
}

export const execute_generator = async function*(method, {service, resource}, payload, config) {
    const { data } = await execute(method, {service, resource}, payload, config)
    yield data
    ? {alert: success_alert, data: data}
    : {alert: error_alert}
}

// FI-1932: authenticated file download. mirrors execute()'s auth header and
// baseURL but returns the raw axios response (blob body + headers) instead of
// unwrapping a json envelope, which a binary body has no shape for. the caller
// reads the filename off content-disposition and turns the blob into a
// download. a 403 clears the session like the json path so an expired jwt
// still bounces to login rather than saving an error blob.
export const download_file = async (method, { service, resource }, config) => {
    const accessToken = localStorage.getItem('jwt')
    try {
        return await client({
            method,
            baseURL: service,
            url: resource,
            responseType: 'blob',
            headers: { Authorization: `Bearer ${accessToken}` },
            ...(config || {}),
        })
    } catch (e) {
        const status = e.response && e.response.status
        if (status == 403) {
            localStorage.clear()
            window.location.href = './#/login'
        }
        throw e
    }
}
